<template>
  <div class="all-center flex-column">
    <h1>404</h1>
    <p>Страница не найдена :(</p>
  </div>
</template>

<style scoped>
.flex-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}
h1 {
  font-size: 100px;
  font-weight: 700;
  color: #000;
}
</style>
